import { JSX, useEffect } from "react";

type Props = {
  active: boolean;
  onInit?: () => void;
  onExit?: () => void;
  children: JSX.Element;
};

export default function WizardStep({
  active,
  onInit,
  onExit,
  children
}: Props) {

  useEffect(() => {
      if (active && !!onInit) {
        onInit(); 
      }

      if (!active && !!onExit) {
        onExit();
      }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active]);

  const activeStyle = {
    display: "block"
  };
  const inactiveStyle = {
    display: "none"
  };

  return(
    <div style={active ? activeStyle : inactiveStyle}>
      {children}
    </div>
  );
}
